// Chapter 4 writing frames ("מסגרות"), uploaded 30.10.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch4_fN"> in src/chapters/chapter-4.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH4_FRAMES: Frame[] = [
  {
    "id": "ch4_f1",
    "n": "4.1",
    "title": "הבור שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי פרשנות. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "איפה ועם מי זה חוזר:",
      "כמה פעמים נפלתי לשם בחודש האחרון:"
    ]
  },
  {
    "id": "ch4_f2",
    "n": "4.2",
    "title": "הבור שלי בחמישה שלבים",
    "type": "lines",
    "intro": "",
    "fields": [
      "א. האירוע (פנימי / חיצוני):",
      "ב. הפרשנות שהמוח המהיר נתן:",
      "ג. הרגש שעלה (שם הרגש, והצבע: ירוק / אדום):",
      "ד. המודעות (תפסתי את עצמי בזמן / רק אחרי / בכלל לא):",
      "ה. התגובה (מה עשיתי בפועל):"
    ]
  },
  {
    "id": "ch4_f3",
    "n": "4.3",
    "title": "מה קרה, בעבר, היום",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלה שמילאת:",
    "fields": [
      "בין הפעם הראשונה לאחרונה בבור, מה השתנה, וכמה שניות לקח הפעם לרגש להתהפך:"
    ]
  },
  {
    "id": "ch4_f4",
    "n": "4.4",
    "title": "ארבע תגובות, אחת שלי",
    "type": "choice5",
    "intro": "הקיפי אחת:",
    "fields": [
      "להילחם · לברוח · לקפוא · להדחיק",
      "ואם הדחקתי, הרגש שדחסתי פנימה הוא:"
    ]
  },
  {
    "id": "ch4_f5",
    "n": "4.5",
    "title": "מה עשיתי, ומה הירוק",
    "type": "twocol",
    "intro": "",
    "fields": [
      "מה עשיתי בפועל בבור|התגובה הירוקה שהייתי בוחרת (גם \"לא להגיב\")"
    ]
  },
  {
    "id": "ch4_f6",
    "n": "4.6",
    "title": "השלב שלי בתרשים",
    "type": "scale2",
    "intro": "1 = האירוע, 6 = פריצת המודעות, 10 = תגובה מחושבת.",
    "fields": [
      "עד איזה שלב הבור שלי מגיע לפני שהאוטומט לוקח",
      "מה היה דרוש לי כדי לעבור את שלב 6 בפעם הבאה:"
    ]
  },
  {
    "id": "ch4_f7",
    "n": "4.7",
    "title": "הנסיבות, הירושה, ההרגל החדש",
    "type": "lines",
    "intro": "",
    "fields": [
      "הנסיבות שחוזרות (מקום / אדם / שעה):",
      "מי במשפחה הגיב ככה לפניי:",
      "ההרגל החדש שאני רוצה במקום (פעולה אחת, משפט אחד):"
    ]
  },
  {
    "id": "ch4_f8",
    "n": "4.8",
    "title": "שני מספרים על חוגה אחת",
    "type": "scale2",
    "intro": "1 = פזיזה לגמרי, 10 = דרוכה לכל גירוי.",
    "fields": [
      "איפה השומרת שלי ביום רגיל",
      "איפה היא הייתה בבור",
      "מה עוזר לי להוריד מספר אחד (שינה / אוכל / הליכה / אדם מסוים):"
    ]
  },
  {
    "id": "ch4_f9",
    "n": "4.9",
    "title": "הסרגל שלי ומשפט הקבלה",
    "type": "lines",
    "intro": "",
    "fields": [
      "הסרגל של הבור שלי (קצה אחד - קצה שני):",
      "לעיתים גם אני...",
      "לעיתים גם הוא / היא...",
      "תנאי ההצלחה שלי לפעם הבאה (ערנית / שבעה / במצב רוח סביר):"
    ]
  },
  {
    "id": "ch4_f10",
    "n": "4.10",
    "title": "דוגמה 5: הבור שלי",
    "type": "twocol_named",
    "intro": "",
    "fields": [
      "מה קרה (שורה אחת):",
      "פרשנות הישרדותית|המציאות (לפחות שתי אפשרויות)",
      "ולמה דווקא אני חשה את זה (רגישות שנבנתה / ירושה):"
    ]
  },
  {
    "id": "ch4_f11",
    "n": "4.11",
    "title": "שני עולמות, בור אחד",
    "type": "twocol",
    "intro": "",
    "fields": [
      "מפחד: הרגש שעולה בבור|מאהבה: הרגש שהיה עולה באותו בור"
    ]
  },
  {
    "id": "ch4_f12",
    "n": "4.12",
    "title": "הסולם שלי",
    "type": "final",
    "intro": "",
    "fields": [
      "בדיקה: מה שבבור הוא פחד / בעצם עצב (אם עצב, מי האדם שאשתף):",
      "שלב 1 - השלב שבו אעצור (מהתרשים, או הסימן הראשון בגוף: הסימן שכתבת בפרק 3 - עדיין אותו? או שהפעם הגיע סימן אחר?):",
      "שלב 2 - השאלה, בניסוח שלי:",
      "שלב 3 - הפרשנות השנייה (מאהבה, לא מפחד):",
      "שלב 4 - התגובה הירוקה:",
      "והמשפט לפעם הבאה: \"זו הרגשתי ברגע זה, ו...\""
    ]
  }
];
